<script>
  import LeadGenForm from "./containers/LeadGenForm/LeadGenForm.svelte";
  import { frameContainer } from "./app.styles";

  export let clientKey;
</script>

<style>
  :global(body, div) {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
</style>

<div class={frameContainer}>
  <LeadGenForm {clientKey} />
</div>
